import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Baik-Mi-106432987566688/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Baik Mi Dang Sushi Facebook"
              />
            </CFLink>
            {/*<CFLink
              target="_blank"
              href="https://www.instagram.com/cravingsbrookswood/"
            >
              <CFImage
                w="55px"
                pr="10px"
                src={instagram}
                alt="Baik Mi Dang Sushi Instagram"
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Baik-Mi-106432987566688/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Baik Mi Dang Sushi Facebook"
              />
            </CFLink>
            {/*<CFLink
              target="_blank"
              href="https://www.instagram.com/cravingsbrookswood/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Baik Mi Dang Sushi Instagram"
                hover
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
